export function isCurrentYear(date: string, today: Date = new Date()) {
	const ref = new Date(date);

	return today.getFullYear() === ref.getFullYear();
}

export function isCurrentMonth(date: string, today: Date = new Date()) {
	const ref = new Date(date);

	return today.getFullYear() === ref.getFullYear();
}

export function isToday(date: string, today: Date = new Date()) {
	const ref = new Date(date);

	return (
		isCurrentYear(date, today) &&
		isCurrentMonth(date, today) &&
		today.getDate() === ref.getDate()
	);
}

const WEEK_LENGTH = 24 * 60 * 60 * 1000 * 7;
/**
 * Tests if given date is a part of current week
 *
 * @param date date to test if is inside the current week interval
 * @param now reference date to evaluate 'current week' against
 * @returns true if given date is a part of current week (with respect to now set)
 */
export function isCurrentWeek(date: string, now: Date = new Date()) {
	const ref = new Date(date);

	// Create a copy of the object to prevent side effects
	const lastSunday = new Date(now.valueOf());
	lastSunday.setDate(lastSunday.getDate() - lastSunday.getDay()); // Setting date to last sunday
	lastSunday.setHours(0, 0, 0, 0); // Setting Hour to 00:00:00:00

	const res =
		lastSunday.getTime() <= ref.getTime() &&
		ref.getTime() < lastSunday.getTime() + WEEK_LENGTH;
	return res;
}
